// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Kt_WH","label":"styles_label__81hLz","motion-blur":"styles_motion-blur__q65bf","btn__copy":"styles_btn__copy__rjtNt"};